import { Component, HostListener } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DriverRecordRequestService } from '../../../services/driverrecordrequest.service';
import { GeneralService } from '../../../services/general.service';
import { IWizard } from '../../../interfaces/iwizard';
import { WizardSteps } from '../../../interfaces/wizard-steps';
import { Router } from '@angular/router';
import { ContactFormInfo } from '../../../interfaces/contact-form-info';
import { environment } from 'src/environments/environment';
import { TranslatorService } from '../../../services/translator.service';

@Component({
    selector: 'app-order-fail',
    templateUrl: './order-fail.component.html',
    styleUrls: ['./order-fail.component.scss'],
    standalone: false
})
export class OrderFailComponent {
     public wizard!: IWizard;

     loginGovUrl: string = '';

     constructor (public _router: Router, 
          public service: DriverRecordRequestService, 
          public generalService: GeneralService, 
          public translatorService: TranslatorService) {
          this.wizard = this.service.getWizard();
     }

     async redirectToLoginGov() {
          let authCode = '';
          await this.generalService.getLoginGovUrl(authCode).toPromise().then((response: string) => {
               this.loginGovUrl = response;
          });

          window.location.href = this.loginGovUrl;
     }

     ngOnInit(): void {
          setTimeout(() => this.scrollToTop(), 500);
          this.translatorService.restoreBackupLanguage();
     }

     localize(url: string) {
          return url.replace(`##baseUrl##`, environment.APP_PSP_BASE_URL);
     }

     translate(translationTag: string) {
          let translatedText: string = this.generalService.getTranslation(translationTag)
          if (translatedText === undefined) {
               translatedText = this.generalService.getTranslation(translationTag);
          }
          return translatedText;
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     @HostListener('window:beforeunload', ['$event'])
     unloadMessage($event: { returnValue: string; }) {
          return $event.returnValue = 'Your changes will not be saved';
     }

}
